/* eslint-disable react/jsx-props-no-spreading */
import { isEmpty } from 'lodash'
import React from 'react'
import { useCookies } from 'react-cookie'
import { Route, Redirect, useHistory } from 'react-router-dom'
import { useSession } from '../contexts/SessionContext'

const AuthRoute = ({ component: Component, ...rest }) => {
  const history = useHistory()
  const [cookies] = useCookies(['statusCookie'])
  const { sessionData } = useSession()

  return (
    <Route
      {...rest}
      render={props =>
        !isEmpty(sessionData) || cookies.statusCookie === '200' ? (
          <Component {...props} {...rest} />
        ) : (
          <Redirect to={{ pathname: '/', state: { referrer: history.location } }} />
        )
      }
    />
  )
}

export default AuthRoute
